export const isUndefined = (value) => typeof value === 'undefined';
